import {
  polePopupTemplate,
  spliceClosurePopupTemplate,
  structurePopupTemplate,
} from "./hooks/usePopupTemplates";

export const createFeatureLayers = ({
  FeatureLayer,
  mapContext,
  GraphicsLayer,
  authCtx,
}) => {
  const getPhotoLayer = () => {
    switch (process.env.REACT_APP_MODE) {
      case "prod":
        return "https://esri.qservco.com/server/rest/services/workforce/photo_storage/MapServer/0";
      case "uat":
        return "";
      case "qa":
        return "https://esri.qservco.com/server/rest/services/PhotoStorageQA/MapServer/0";
      default:
        return "https://esri.qservco.com/server/rest/services/photo_storage_development/MapServer/0";
    }
  };

  const photoPointLayer = new FeatureLayer({
    url: getPhotoLayer(),
    visible:
      mapContext?.layerVisibility?.photoPoints != null
        ? mapContext.layerVisibility.photoPoints
        : true,
    title: "Photo Points",
    id: "photoPoints",
    outFields: ["*"],
  });

  const addressLayer = new FeatureLayer({
    url:
      process.env?.REACT_APP_MODE === "prod"
        ? "https://esri.qservco.com/server/rest/services/NOC/NOC_Replacement/MapServer/5"
        : "https://esri.qservco.com/server/rest/services/Collector_Suite_Design_Layers_GIS20/MapServer/1",
    visible: mapContext?.layerVisibility?.address || false,
    title: "Addresses",
    id: "address",
    outFields: ["*"],
  });

  const conduitLayer = new FeatureLayer({
    url:
      process.env?.REACT_APP_MODE === "prod"
        ? "https://esri.qservco.com/server/rest/services/NOC/NOC_Replacement/MapServer/6"
        : "https://esri.qservco.com/server/rest/services/Collector_Suite_Design_Layers_GIS20/MapServer/8",
    visible: mapContext?.layerVisibility?.conduit || false,
    title: "Conduit",
    id: "conduit",
    outFields: ["*"],
  });

  const fiberCableLayer = new FeatureLayer({
    url:
      process.env?.REACT_APP_MODE === "prod"
        ? "https://esri.qservco.com/server/rest/services/NOC/NOC_Replacement/MapServer/7"
        : "https://esri.qservco.com/server/rest/services/Collector_Suite_Design_Layers_GIS20/MapServer/9",
    visible: mapContext?.layerVisibility?.fibercable || false,
    title: "Fiber Cable",
    id: "fibercable",
    outFields: ["*"],
  });

  const lcpLayer = new FeatureLayer({
    url:
      process.env?.REACT_APP_MODE === "prod"
        ? "https://esri.qservco.com/server/rest/services/NOC/NOC_Replacement/MapServer/4"
        : "https://esri.qservco.com/server/rest/services/Collector_Suite_Design_Layers_GIS20/MapServer/12",
    visible:
      mapContext?.layerVisibility?.lcpBoundaries != null
        ? mapContext.layerVisibility.lcpBoundaries
        : true,
    title: "LCP Boundaries",
    id: "lcpBoundaries",
    outFields: ["*"],
  });

  const parcelLayer = new FeatureLayer({
    url:
      process.env?.REACT_APP_MODE === "prod"
        ? "https://esri.qservco.com/server/rest/services/NOC/NOC_Replacement/MapServer/15"
        : "https://esri.qservco.com/server/rest/services/Collector_Suite_Design_Layers_GIS20/MapServer/14",
    visible: mapContext?.layerVisibility?.parcels || false,
    title: "Parcels",
    id: "parcels",
    outFields: ["*"],
  });

  const polesLayer = new FeatureLayer({
    url:
      process.env?.REACT_APP_MODE === "prod"
        ? "https://esri.qservco.com/server/rest/services/NOC/NOC_Replacement/MapServer/12"
        : "https://esri.qservco.com/server/rest/services/Collector_Suite_Design_Layers_GIS20/MapServer/5",
    visible:
      mapContext?.layerVisibility?.poles != null
        ? mapContext.layerVisibility.poles
        : true,
    title: "Poles",
    id: "poles",
    outFields: ["*"],
    popupTemplate: polePopupTemplate(),
  });

  const spliceClosureLayer = new FeatureLayer({
    url:
      process.env?.REACT_APP_MODE === "prod"
        ? "https://esri.qservco.com/server/rest/services/NOC/NOC_Replacement/MapServer/3"
        : "https://esri.qservco.com/server/rest/services/Collector_Suite_Design_Layers_GIS20/MapServer/0",
    visible:
      mapContext?.layerVisibility?.spliceClosures != null
        ? mapContext.layerVisibility.spliceClosures
        : true,
    title: "Splice Closures",
    id: "spliceClosures",
    outFields: ["*"],
    popupTemplate: spliceClosurePopupTemplate(),
  });

  const strandLayer = new FeatureLayer({
    url:
      process.env?.REACT_APP_MODE === "prod"
        ? "https://esri.qservco.com/server/rest/services/NOC/NOC_Replacement/MapServer/8"
        : "https://esri.qservco.com/server/rest/services/Collector_Suite_Design_Layers_GIS20/MapServer/10",
    visible: mapContext?.layerVisibility?.strand || false,
    title: "Strand",
    id: "strand",
    outFields: ["*"],
  });

  const structureLayer = new FeatureLayer({
    url:
      process.env?.REACT_APP_MODE === "prod"
        ? "https://esri.qservco.com/server/rest/services/NOC/NOC_Replacement/MapServer/9"
        : "https://esri.qservco.com/server/rest/services/Collector_Suite_Design_Layers_GIS20/MapServer/2",
    visible:
      mapContext?.layerVisibility?.structures != null
        ? mapContext.layerVisibility.structures
        : true,
    title: "Structures",
    id: "structures",
    outFields: ["*"],
    popupTemplate: structurePopupTemplate(),
  });

  const graphicsLayer = new GraphicsLayer({
    visible: true,
    title: "Graphics",
    id: "graphics",
  });

  return {
    addressLayer: addressLayer,
    conduitLayer: conduitLayer,
    fiberCableLayer: fiberCableLayer,
    graphicsLayer: graphicsLayer,
    lcpLayer: lcpLayer,
    parcelLayer: parcelLayer,
    photoPointLayer: photoPointLayer,
    polesLayer: polesLayer,
    spliceClosureLayer: spliceClosureLayer,
    strandLayer: strandLayer,
    structureLayer: structureLayer,
  };
};
